/* unfortunately not functional at the time, just for show */

import React from "react"

const Options = () => {
  return (
    <div id="options">
      <span className="options">
        <span className="underline">E</span>dit
        <span className="underline">V</span>iew
        <span className="underline">H</span>elp
      </span>
    </div>
  )
}

export default Options
